export type ParticleQaPatchChangeScope =
  | 'answer_only'
  | 'question_and_answer'
  | 'format_only';

export type ParticleQaPatch = {
  particleId?: string;
  changeScope: ParticleQaPatchChangeScope;
  summary: string;
  questions?: unknown;
  answers?: unknown;
};

const PATCH_FENCE_RE = /```particle_qa_patch\s*([\s\S]*?)```/i;

function asRecord(value: unknown): Record<string, unknown> | null {
  return value && typeof value === 'object' && !Array.isArray(value)
    ? value as Record<string, unknown>
    : null;
}

function normalizeChangeScope(value: unknown): ParticleQaPatchChangeScope {
  const raw = String(value || '').trim().toLowerCase();
  if (raw === 'question_and_answer' || raw === 'qa' || raw === 'both') return 'question_and_answer';
  if (raw === 'format_only' || raw === 'format') return 'format_only';
  return 'answer_only';
}

export function parseParticleQaPatchFromText(text: string): ParticleQaPatch | null {
  const match = String(text || '').match(PATCH_FENCE_RE);
  if (!match?.[1]) return null;
  try {
    const parsed = JSON.parse(match[1].trim()) as unknown;
    const record = asRecord(parsed);
    if (!record) return null;
    const answers = record.answers ?? record.answer ?? record.Answers ?? record.Answer;
    const questions = record.questions ?? record.question ?? record.Questions ?? record.Question;
    const summary = String(record.summary || record.reason || record.rationale || '').trim();
    if (answers == null && questions == null) return null;
    return {
      particleId: String(record.particleId || record.particle_id || '').trim() || undefined,
      changeScope: normalizeChangeScope(record.changeScope || record.change_scope || record.scope),
      summary: summary || '修订知识颗粒 Q/A',
      ...(questions != null ? { questions } : {}),
      ...(answers != null ? { answers } : {}),
    };
  } catch {
    return null;
  }
}

export function stripParticleQaPatchFence(text: string): string {
  return String(text || '')
    .replace(PATCH_FENCE_RE, '')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
}
